import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { VacationApplicationsState } from '@/store/applications/vacations/types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters'

const VacationApplications: Module<VacationApplicationsState, RootState> = {
  state: () => ({
    applications: [],
    pager: {
      current: 1,
      last: 1,
      totalLength: 0,
    },
  }),
  mutations,
  actions,
  getters,
};

export default VacationApplications
